/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Balíček doručen`
};

const da_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Pakke leveret`
};

const de_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Paket geliefert`
};

const en_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Parcel delivered`
};

const es_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Paquete entregado`
};

const fr_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Colis livré`
};

const hu_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Csomag leszállítva`
};

const it_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Pacco consegnato`
};

const nl_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Pakket geleverd`
};

const pl_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Paczka dostarczona`
};

const pt_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Encomenda entregue`
};

const sv_order_statuses_complete_delivered = /** @type {(inputs: {}) => string} */ () => {
	return `Paket levererat`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete_delivered = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete_delivered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete_delivered", locale)
	if (locale === "cs") return cs_order_statuses_complete_delivered(inputs)
	if (locale === "da") return da_order_statuses_complete_delivered(inputs)
	if (locale === "de") return de_order_statuses_complete_delivered(inputs)
	if (locale === "en") return en_order_statuses_complete_delivered(inputs)
	if (locale === "es") return es_order_statuses_complete_delivered(inputs)
	if (locale === "fr") return fr_order_statuses_complete_delivered(inputs)
	if (locale === "hu") return hu_order_statuses_complete_delivered(inputs)
	if (locale === "it") return it_order_statuses_complete_delivered(inputs)
	if (locale === "nl") return nl_order_statuses_complete_delivered(inputs)
	if (locale === "pl") return pl_order_statuses_complete_delivered(inputs)
	if (locale === "pt") return pt_order_statuses_complete_delivered(inputs)
	return sv_order_statuses_complete_delivered(inputs)
};
export { order_statuses_complete_delivered as "order_statuses.complete_delivered" }